var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('success',{attrs:{"title":_vm.title,"type":_vm.type,"showBottomCloseBtn":false}},[(_vm.failMsg)?_c('p',{staticStyle:{"color":"#888"}},[_vm._v("失败原因："+_vm._s(_vm.failMsg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }